import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Form, Row, Col, Input, Button, Select, Cascader } from 'antd';
import { toJS } from 'mobx';
@inject('indexManagementStore')
@observer
class FormModal extends Component {
  state = {
    dataType: "OUTBOUND",
    apiNameValue: '',
    fieldInfos: {}
  }
  formRef = React.createRef();
  componentDidMount() {
    const { indexManagementStore, title } = this.props
    const { detailsObj } = indexManagementStore
    indexManagementStore.onGetApiNameAction({ dataType: "OUTBOUND" })
    if (title === 'edit') {
      this.setState({
        apiNameValue: detailsObj?.apiName,
      })
      indexManagementStore.onGetSampleDataAction(detailsObj?.apiConfigId)
      this.formRef.current.setFieldsValue({
        direction: detailsObj?.direction,
        apiName: detailsObj?.apiConfigId,
        indexName: detailsObj?.indexName,
        indexPath: detailsObj?.indexPath?.split("."),
      })
    } else {
      this.formRef.current.setFieldsValue({
        dataType: "OUTBOUND",
        indexPath: null
      })
      this.setState({
        apiNameValue: ''
      })
    }
    indexManagementStore.onChangeSampleData([])
  }
  handleOk = () => {
    const { indexManagementStore, handleCancel, title } = this.props
    const { detailsObj } = indexManagementStore
    const { fieldInfos } = this.state
    let newFieldInfos = []
    newFieldInfos = JSON.parse(JSON.stringify(fieldInfos)?.replace(/"tree"/g, '"children"').replace(/\//g, '.'))
    for (var i = newFieldInfos.length - 1; i >= 1; i--) {
      newFieldInfos[i - 1].children = newFieldInfos[i]
    }
    this.formRef.current.validateFields().then(fieldsValue => {
      const params = {
        // "dataType": fieldsValue.dataType,
        // "apiId": fieldsValue.apiName,
        "fieldInfos": title==='edit'&& JSON.stringify(fieldInfos) === '{}' ? detailsObj.fieldInfos: toJS(newFieldInfos[0]),
        // "indexName": fieldsValue.indexName,
        // "indexPath": fieldsValue.indexPath.toString().replace(/,/g, '.').replace(/\//g, '.'),
        // "sampleData": "",
        // "active": title==='edit'?detailsObj.active:false
        direction: this.state.dataType,
        apiConfigId: fieldsValue.apiName,
        indexName: fieldsValue.indexName,
        indexPath: fieldsValue.indexPath.toString().replace(/,/g, '.').replace(/\//g, '.'),
      }
      console.log('params', params);
      if (title === 'edit') {
        indexManagementStore.onEditAction(params, detailsObj.id).then(res => {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        indexManagementStore.onAddAction(params).then(res => {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch(err => { })
  }
  onChange = (value) => {
    const { indexManagementStore } = this.props
    this.setState({
      dataType: value
    })
    indexManagementStore.onGetApiNameAction({ dataType: value })
  }
  onChangeApiName = (value) => {
    const { indexManagementStore } = this.props
    indexManagementStore.onGetSampleDataAction(value)
    this.setState({
      apiNameValue: value,
    })
    this.formRef.current.setFieldsValue({ indexPath: '' })
  }
  onChangePath = (value, option) => {
    this.setState({
      fieldInfos: option
    })
  }
  displayRender = (labels) => {
    return labels.join('.')
  }
  render() {
    const { indexManagementStore, addModalVisible, handleCancel, title } = this.props
    const { apiNameList, sampleData } = indexManagementStore
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    }
    return (
      <Modal
        title={title === 'edit' ? "Edit Index Set" : "Add Index Set"}
        closable={false}
        visible={addModalVisible}
        // onOk={this.handleOk}
        // onCancel={handleCancel}
        maskClosable={false}
        destroyOnClose={true}
        centered
        footer={[
          <Button key="Save" type='primary' onClick={this.handleOk}>Save</Button>,
          <Button key="Cancel" onClick={handleCancel}>Cancel</Button>,
        ]}
        width='50%'
      >
        <Form ref={this.formRef} initialValues={{ direction: 'OUTBOUND' }} key='addMapping'>
          <Row>
            <Col span={24}>
              <Row justify='start' gutter={[10, 10]}>
                <Col xs={24} sm={24} md={24} span={24} >
                  <Form.Item name='direction' label='Direction' {...formItemLayout} rules={[{ required: true, message: 'Please select Direction.' }]}>
                    <Select placeholder="Please select ..." onChange={this.onChange} disabled={title === 'edit'}>
                      <Select.Option key='INBOUND' value='INBOUND'>INBOUND</Select.Option>
                      <Select.Option key='OUTBOUND' value='OUTBOUND'>OUTBOUND</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} span={24} >
                  <Form.Item name='apiName' label='API Name' {...formItemLayout} rules={[{ required: true, message: 'Please select API Name.' }]}>
                    <Select placeholder="Please select ..." allowClear showSearch onChange={this.onChangeApiName} disabled={title === 'edit'}>
                      {apiNameList.length > 0 ? apiNameList.map(item => <Select.Option key={item.apiName} value={item.id}>{item.apiName}</Select.Option>) : null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} span={24} >
                  <Form.Item name='indexName' label="Index Name" {...formItemLayout} rules={[{ required: true, message: 'Please enter Index Name without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                    <Input maxLength={100} placeholder="Please enter ..." disabled={title === 'edit'} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} span={24} >
                  <Form.Item name='indexPath' label="Index Path" {...formItemLayout} rules={[{ required: true, message: 'Please select Index Path.' }]}>
                    <Cascader
                      changeOnSelect={true}
                      fieldNames={{ label: 'path', value: 'path', children: 'tree' }}
                      options={sampleData.length > 0 ? sampleData : null}
                      // disabled={title==='edit'?this.state.apiNameValue ==='' || !sampleData.length>0 : !sampleData.length>0}
                      disabled={title === 'edit'}
                      onChange={this.onChangePath}
                      displayRender={this.displayRender}
                      placeholder="Please select" />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default FormModal;
